module.exports = __webpack_public_path__ + "static/media/stand_01.4b24ded5.usdz";